import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import google from "../../../assets/DigitalMarketing/image/integration/google.svg";
import facebookbtn from "../../../assets/DigitalMarketing/image/integration/icon_facebook_btn.svg";
import vector from "../../../assets/DigitalMarketing/image/integration/Vector.svg";
import logo from "../../../assets/DigitalMarketing/image/integration/Group 1000002636.svg";
import { GoogleLabel } from "./utils";
import {
  useAddGoogleAnalyticsMutation,
  useGetGoogleAnalyticsbyIdQuery,
} from "../../../Service/Integration";

function GoogleDetail() {
  const dispatch = useDispatch<any>();
  const [googleAnalytics, setGoogleAnalytics] = useState([]);
  const { open, message, openSnackBar, type } = useSnackbar();
  const [addGoogleAnalytics] = useAddGoogleAnalyticsMutation();
  const response: any = useGetGoogleAnalyticsbyIdQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    response?.data?.[0] && setGoogleAnalytics(response?.data?.[0]);
  }, [response?.data?.[0]]);
  const OnhandleChange = (event) => {
    const { name, value } = event.target;
    setGoogleAnalytics((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleUpdate = async () => {
    try {
      const payload = await addGoogleAnalytics(googleAnalytics).unwrap();
      // console.log("fulfilled", payload);
      openSnackBar("Updated successfully");
    } catch (error: any) {
      openSnackBar(error.data.error, "error");
      console.error("rejected", error);
    }
  };
  return (
    <React.Fragment>
      <Toast open={open} type={type} message={message} />
      <Container fluid>
        <Row className="integration-facebooklayout">
          <Col md={8} className="integration-facebook mt-4">
            <div className="d-flex justify-content-center px-5">
              <img className="icon-img3 mt-1 " src={logo} alt="logo" />
              <img className="login-logo mt-3 mx-3" src={vector} alt="vector" />
              <img className="icon-img3 mt-1" src={google} alt="google" />
            </div>
            <h1 className="facebook-message">
              Receive new leads from Google & Integration Lead Ads in your Mind
              and Mom account
            </h1>
            <div className="facebook-message">
              {GoogleLabel.map((item) => (
                <div className="mt-3">
                  <item.tag
                    {...item}
                    {...googleAnalytics}
                    handleChange={OnhandleChange}
                  />
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center">
              <Button
                className="facebook btn"
                variant="contained"
                id="btn-google"
                onClick={handleUpdate}
              >
                <span>
                  <img className="icon-btnfb" src={google} alt="facebook" />
                </span>{" "}
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}
export default React.memo(GoogleDetail);
